









































































































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class InfoPesertaTabView extends Vue {
  @Prop() readonly info!: any;
  @Prop() readonly loading!: boolean;
  @Prop() readonly message: string | null;

  get renderedInfo() {
    const item = this.info;

    item.noMr = item.noMr ?? "-";
    item.telp = item.telp ?? "-";

    item.faskes = item.faskesPrimer.id
      ? `${item.faskesPrimer.name} - ${item.faskesPrimer.id}`
      : "-";

    item.informasi.dinsos = item.informasi.dinsos ?? "-";
    item.informasi.noSKTM = item.informasi.noSKTM ?? "-";
    item.informasi.prolanisPRB = item.informasi.prolanisPRB ?? "-";

    item.cob.nama = item.cob.nama ?? "-";
    item.cob.nomor = item.cob.nomor ?? "-";
    item.cob.tglTAT = item.cob.tglTAT ?? "-";
    item.cob.tglTMT = item.cob.tglTMT ?? "-";

    item.sex =
      item.sex === "L" ? "Laki-laki" : item.sex === "P" ? "Perempuan" : "-";

    return item;
  }
}
